export default "__VITE_ASSET__DGrATKmN__"